export const PUSH_NOTIFICATIONS_PROMPT_STATUSES = {
    NOT_TRIGGERED: 'NOT_TRIGGERED',
    TRIGGERED: 'TRIGGERED',
    PROMPT_SHOWN: 'PROMPT_SHOWN',
};
